import queryString from 'query-string';
import { saveAs } from 'file-saver';

import request, { apiBaseUrl } from '@/utils/request';
import { XCSRFHeader } from '@/utils/auth';

export const ADMIN_SUBSCRIPTIONS = 'ADMIN_SUBSCRIPTIONS';
export const ADMIN_SUBSCRIPTIONS_SUMMARY = 'ADMIN_SUBSCRIPTIONS_SUMMARY';
export const ADMIN_SUBSCRIPTIONS_CSV = 'ADMIN_SUBSCRIPTIONS_CSV';

export const fetchSubscriptions =
  (query = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/admin/subscriptions`,
      query
    });
    dispatch({
      payload: response,
      type: ADMIN_SUBSCRIPTIONS
    });
    return response;
  };

export const fetchSubscriptionsSummary =
  (query = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/admin/subscriptions/summary`,
      query
    });
    dispatch({
      payload: response,
      type: ADMIN_SUBSCRIPTIONS_SUMMARY
    });
    return response;
  };

const DEFAULT_EXPORT_FILENAME = 'subscriptions.csv';

const exportFilename = response => {
  const disposition = response.headers.get('Content-Disposition');
  const match = disposition && disposition.match(/filename="?([^";]+)"?/i);

  return match ? match[1].trim() : DEFAULT_EXPORT_FILENAME;
};

export const exportSubscriptionsCSV =
  ({ all, ids, sub_type, status, q, payment_type, renew }) =>
  async dispatch => {
    const url = `${apiBaseUrl()}/v1/admin/subscriptions/export.csv?&all=${all}&${queryString.stringify(
      { ids, sub_type, status, q, payment_type, renew },
      { arrayFormat: 'bracket' }
    )}`;

    await fetch(url, {
      headers: Object.assign({ 'Content-Type': 'application/json' }, XCSRFHeader()),
      credentials: 'include',
      responseType: 'blob'
    }).then(response =>
      dispatch({
        payload: response.blob().then(blob => saveAs(blob, exportFilename(response))),
        type: ADMIN_SUBSCRIPTIONS_CSV
      })
    );
  };
